import { useMutation } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { DCSQueryClient } from "../../../queryClient";
import { SectionHeader } from "../../../components/SectionHeader/SectionHeader";
import { useToast } from "../../../Providers/ToastProvider";
import { requests } from "../../../services/http-common";
import { EmployeeForm } from "../EmployeeForm/EmployeeForm";

export const EmployeeCreate = () => {
  const navigate = useNavigate();
  const { show } = useToast();

  const createEmployee = useMutation({
    mutationFn: (newLead: any) => {
      return requests.post("/user", { ...newLead, sendStatus: false });
    },
    onSuccess: () => {
      show({ detail: "Employee was created successfully !" });
      navigate("/management/employees");
      DCSQueryClient.invalidateQueries({ queryKey: ["employee-list"] });
    },
    onError: (error: any) => {
      show({
        severity: "error",
        detail: error.response?.data?.error?.message || "Something went wrong ",
      });
    },
  });

  return (
    <>
      <SectionHeader title="Create an Employee Record" />
      <EmployeeForm
        onSubmit={createEmployee.mutate}
        isPending={createEmployee.isLoading}
      />
    </>
  );
};
